import { render, staticRenderFns } from "./pageCreator.vue?vue&type=template&id=519d6d9e"
import script from "./pageCreator.vue?vue&type=script&lang=js"
export * from "./pageCreator.vue?vue&type=script&lang=js"
import style0 from "./pageCreator.vue?vue&type=style&index=0&id=519d6d9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports